import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { compose } from 'redux';
import classnames from 'classnames';

import { injectConfig, configShape } from '@client/hoc/config';
import CampaignLabel from '../campaigns/CampaignLabel';
import CampaignOverlay from '../campaigns/CampaignOverlay';
import { buildCampaignUrl } from '../../../helpers/campaignUrl';

import styles from './index.scss';

export const HiddenCampaign = ({
    campaign,
    config,
    onGrid = false,
}) => {
    if (!campaign) {
        return null;
    }

    const campaignId = `campaign-${campaign.campaignIdentifier}`;
    const destination = buildCampaignUrl(campaign.campaignIdentifier);
    const imageUrl = `${config.getUrl('campaign', campaign.hasLogo)}${onGrid ? campaign.imageGrid : campaign.image}`;
    const dimension = onGrid ? '1x1' : '2x1';

    return (
        <div styleName={classnames('wrapper', { 'on-grid': onGrid })}>
            <a
                href={destination}
                id={campaignId}
                styleName="link"
            >
                <div styleName="link-inner-wrapper">
                    <div styleName="img">
                        <img src={imageUrl} alt={campaign.name} />
                    </div>
                    <div styleName="overlay">
                        <CampaignOverlay
                            name={campaign.name}
                            bannerText={campaign.bannerText}
                            dimension={dimension}
                            hover
                        />
                    </div>
                    <div styleName="label">
                        <CampaignLabel
                            discount={campaign.discount.value}
                            dimension={dimension}
                            campaign={campaign}
                        />
                    </div>
                </div>
            </a>
        </div>
    );
};

HiddenCampaign.propTypes = {
    campaign: PropTypes.object,
    onGrid: PropTypes.bool,
    config: configShape,
};

export const withStyles = (Component) => CSSModules(Component, styles, { allowMultiple: true });

export default compose(
    injectConfig,
    withStyles,
)(HiddenCampaign);
